import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	groupField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.group-field',
		defaultMessage: 'Group',
		description: 'text of third party group',
	},
	mondayItemField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.monday-item-field',
		defaultMessage: 'Item',
		description: 'text of Monday item',
	},
	mondaySubItemField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.monday-sub-item-field',
		defaultMessage: 'Subitem',
		description: 'text of Monday subitem',
	},
	sectionField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.section-field',
		defaultMessage: 'Section',
		description: 'text of third party section',
	},
	taskField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.task-field',
		defaultMessage: 'Task',
		description: 'text of third party task',
	},
	subtaskField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.subtask-field',
		defaultMessage: 'Subtask',
		description: 'text of third party subtask',
	},
	nestedSubtaskField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.nested-subtask-field',
		defaultMessage: 'Nested subtask',
		description: 'text of third party nested subtask',
	},
	epicField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.epic-field',
		defaultMessage: 'Epic',
		description: 'text of third party nested subtask',
	},
	listField: {
		id: 'project-create-importer-upload-flow.common.utils.third-party-mapping.list-field',
		defaultMessage: 'List',
		description: 'text of third party list',
	},
});
